<ng-template #fabContent>
  <div class="button-content">
    <ng-content></ng-content>
    <mat-icon class="mat-icon" *ngIf="icon">{{ icon }}</mat-icon>
    <span class="mat-button-wrapper" *ngIf="label && extended">{{ label }}</span>
  </div>

  <ng-template [ngIf]="isLoadingState">
    <mat-spinner [diameter]="diameter" [strokeWidth]="strokeWidth"></mat-spinner>
  </ng-template>
</ng-template>

<ng-container [ngSwitch]="true">
  <button *ngSwitchCase="extended" mat-extended-fab [type]="type" [disabled]="isDisabledState">
    <ng-container *ngTemplateOutlet="fabContent"></ng-container>
  </button>

  <button *ngSwitchCase="small" mat-mini-fab [type]="type" [disabled]="isDisabledState">
    <ng-container *ngTemplateOutlet="fabContent"></ng-container>
  </button>

  <button *ngSwitchDefault mat-fab [type]="type" [disabled]="isDisabledState">
    <ng-container *ngTemplateOutlet="fabContent"></ng-container>
  </button>
</ng-container>
